<template>
  <div>
<h2 class="goth">Possessiva pronomen</h2>


<div class="grammatikparagrafbredd leftorient">

    <p>Possessiva pronomen kallas sådana pronomen som betecknar ägande.
        T.ex. <i>min, din, hans, hennes </i>.</p>

    <br>
<h4>Possessiva pronomen</h4>

    <table class=" fixbredd">


        <tr class="leftorient">
            <td class="ljusgra"><i>min</i></td>
            <td class="ljusgra"><i><b>mein</b></i></td>
        </tr>

        <tr class="leftorient">

            <td class="ljusgra"><i>din</i></td>
            <td class="ljusgra"><i><b>dein</b></i></td>
        </tr>

        <tr class="leftorient">


            <td class="ljusgra"><i>hans<br> dess &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(sin)<br> hennes</i></td>
            <td class="ljusgra"><i><b>sein<br>sein<br>ihr</b></i></td>
        </tr>
<tr></tr>
        <tr class="leftorient">
            <td class="ljusgra"><i>vår</i></td>
            <td class="ljusgra"><i><b>unser</b></i></td>
        </tr>

        <tr class="leftorient">

            <td class="ljusgra"><i>er</i></td>
            <td class="ljusgra"><i><b>euer</b></i></td>
        </tr>

        <tr class="leftorient">

            <td class="ljusgra"><i>deras &nbsp;&nbsp;&nbsp;&nbsp;(sin)<br> Er</i></td>
            <td class="ljusgra"><i><b>ihr<br> Ihr</b></i></td>
        </tr>


    </table>







<br><br>

<p>De possessiva pronomina får ändelser som beror på det ägdas
    genus och kasus, på samma sätt som <i>ein, kein</i> o.s.v.</p>

<br>

<div class="ruta">

<p><i>Dein Hund </i>(m)<i> ist braun. <br>
    Din hund är brun.
</i></p>

<p><i>Dein Haus </i>(n)<i> ist groß. <br>
    Ditt hus är stort.
</i></p>

<p><i>Dein<b>e</b> Katze </i>(f)<i> ist grau. <br>
    Din katt är grå.
</i></p>


<p><i>Dein<b>e</b> Kinder </i>(pl)<i> sind süß. <br>
    Dina barn är söta.
</i></p>
<br>



<p><i>Hast du mein<b>en</b> Bruder </i>(m. ack.)<i> gesehen? <br>
    Har du sett min bror?
</i></p>

<p><i>Mit ihr<b>en</b> Sache<b>n</b> </i> (plur.dat.)<i> können sie vieles tun. <br>
    Med sina saker kan de göra mycket.
</i></p>
</div>

<br><br>

<h4>Sin</h4>
<p>Observera att ordet <i>sin</i>, som sådant inte existerar på tyska.
    <i>Sin</i> används på svenska när något ägt stå i objektsform och ägaren är
    samma som subjektet i satsen (och står i 3:e person). I de fallen görs på svenska ingen skillnad om ägaren är
femininum eller maskulinum (eller plural).</p>

<p>På tyska måste man dock alltid använda <i>ihr (=hennes)</i> om ägaren är femininum singular, <i>sein (=hans / dess)</i> om ägaren
    är maskulinum eller neutrum singular och <i>ihr (=deras)</i> om ägarna är plural.</p>


<br>
<div class="ruta">
    <p><i>Kalle holt <b>sein</b> Auto. <br>
        Kalle hämtar <b>sin</b> bil.
    </i></p>


    <p><i>Lisa holt <b>ihr</b> Auto. <br>
        Lisa hämtar <b>sin</b> bil.
    </i></p>

    <p><i>Die Teenager holen <b>ihre</b> Autos. <br>
        Tonåringarna hämtar <b>sina</b> bilar.
    </i></p>
</div>

<br><br>


<div class="mindre">

<h4>Självständiga possessiva pronomen</h4>

<p>I samtliga exempel ovan står de possessiva pronomina före det ägda s.k. <i>förenade possessiva pronomen</i>.
    Om ett possessivt pronomen står efter det ägda, eller att
    det ägda inte alls nämns, kallas de <i>självständiga possessiva pronomen</i> (j.fr. engelskans <i>mine, yours</i> o.s.v).
    De får då ändelser som motsvarar det ägdas bestämnda artikel.</p>

<div class="ruta">
<table style="width:100%">

<tr>
<th>förenat</th>
<th>självständigt</th>
</tr>

    <tr>
    <td>
        <i>Es ist dein Hund.</i>
    </td>
    <td>
        <i>Der Hund ist dein<b>er</b></i>
    </td>
    </tr>

    <tr>
    <td>
        <i>Det är din hund.</i>
    </td>
    <td>
        <i>Hunden är din.</i>
    </td>
    </tr>

<tr></tr>
<tr></tr>


    <tr>
    <td>
        <i>Es ist mein Auto.</i>
    </td>
    <td>
        <i>Das Auto ist mein<b>es</b></i>
    </td>
    </tr>

    <tr>
    <td>
        <i>Det är min bil.</i>
    </td>
    <td>
        <i>Bilen är min.</i>
    </td>
    </tr>

    <tr></tr>
    <tr></tr>


        <tr>
        <td>
            <i>Es ist seine Katze.</i>
        </td>
        <td>
            <i>Die Katze ist sein<b>e</b></i>
        </td>
        </tr>

        <tr>
        <td>
            <i>Det är hans katt.</i>
        </td>
        <td>
            <i>Katten är hans.</i>
        </td>
        </tr>


        <tr></tr>
        <tr></tr>


        <tr>
        <td>
            <i>Es sind unsere Kinder.</i>
        </td>
        <td>
            <i>Die Kinder sind unser<b>e</b></i>
        </td>
        </tr>

        <tr>
        <td>
            <i>Det är våra barn.</i>
        </td>
        <td>
            <i>Barnen är våra.</i>
        </td>
        </tr>




</table>
</div>

</div>

</div>

</div>

</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "possessiva ägande pronomen"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

th {
    font-weight: bold;
}
</style>
